import { Box, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import { useState } from "react";
import AreaChart from "src/components/ScoringChart/AreaChart";
import { beautifulTooltip } from "src/components/ScoringChart/tool-utils/BeautifulTooltip";
import TitleTypography from "src/components/Typography/TitleTypography";
import PaperWrapper from "src/components/Wrapper/PaperWrapper";
import { useReputationSelector } from "src/context/reputationContext";
import LockHoverButton from "../LockHoverButton";

const useStyles = makeStyles(() => ({
  root: {
    padding: "20px",
    position: "relative",
    height: 260,
  },
  fogContent: {
    filter: "blur(4px)",
  },
}));

const options = {
  chart: { height: 220 },
  xAxis: {
    type: "datetime",
    tickAmount: 3,
  },
  yAxis: {
    tickAmount: 6,
    labels: {
      enabled: true,
    },
    max: 5,
    min: 0,
    gridLineWidth: 1,
  },
  ...beautifulTooltip((value) => value),
};

export default function ReputationRankHistory({ isEmpty, onBuyTRAVAClick }) {
  const cls = useStyles();

  const [isShowLock, setShowLock] = useState(true);
  const reputationUser = useReputationSelector((state) => state.reputationUser);
  const rankHistory = useReputationSelector((state) => {
    if (!state.reputationUser) return [];
    return state.reputationUser.rankHistory;
  });

  const category = Object.keys(rankHistory);
  const dataChart = Object.values(rankHistory);
  const data = category.map((item, index) => [item * 1000, dataChart[index]]);
  const series = [{ name: "Rank", data: data }];

  return (
    <PaperWrapper
      onMouseEnter={() => setShowLock(false)}
      onMouseLeave={() => setShowLock(true)}
      paperProps={{ className: cls.root }}
      title="Reputation Rank History"
    >
      <Box width="100%" height="100%" className={(clsx, { [cls.fogContent]: isEmpty })}>
        {reputationUser ? (
          <AreaChart series={series} option={options} />
        ) : (
          <Box display="flex" justifyContent="center" alignItems="center" height="100%">
            <TitleTypography textProps={{ variant: "h4" }} title="Please connect your wallet first!" />
          </Box>
        )}
      </Box>
      {isEmpty && <LockHoverButton isShowLock={isShowLock} onBuyTRAVAClick={onBuyTRAVAClick} />}
    </PaperWrapper>
  );
}
